import { useTranslation } from "react-i18next";
import IdentificationFlow from "./IdentificationFlow";

export default function IdentificationScreen() {
  const { t } = useTranslation();

  return <IdentificationFlow backTo="/settings" parentName={t("Settings")} />;
}
